<template>
  <student-list-dt />
</template>
<script>

import StudentListDt from '@/views/pages/student-list/StudentListDt.vue'

export default {
  components: { StudentListDt },
}
</script>
